const common = {
  Test: 'Test',
  Save: 'Lưu',
};

export default common;
